declare var STATIC_BASE_URL:string;
declare var BASE_URL:string;

import '../styles/forbes.scss';
import '../styles/forbesproducts.scss';

import { h, Component } from 'preact';

export default class Forbes extends Component<any, any> {

    constructor() {
        super();
    }

    public render (props, state): any {
      
      const calltoaction = <p class="center calltoaction">
        <a href="mailto:info@querlo.com?subject=hr assistant | request a demo" class="butt huge">Request a demo</a>
      </p>;

        return <div id="forbesleadinsights" class="forbes">
          <section class="full withBackground" style={{backgroundImage: "url(" + STATIC_BASE_URL + 'images/public/forbes-insights-top.jpg' + ")"}}>
            <div class="titleWrp">
              <h1>Enterprise AI Solutions<br />AI Employee Experience Platform</h1>
              <div class="logoWrp">
                <div>AI solutions powered by Querlo</div>
              </div>
            </div>
            
            { calltoaction }
          </section>
          <section id="cloudExplainWrp">
            <h2>
              How an AI Digital Assistant works
            </h2>
            <div id="cloudexplain">
              <img class="computer" src={ STATIC_BASE_URL + 'images/public/forbes-insight-computer.jpg'} alt="querlo on a portable computer"/>
              <img class="bidi-arrows" src={ STATIC_BASE_URL + 'images/public/icons/bidirectional-arrows.svg'} alt="bidirectional data communication"/>
              <img class="cloud" src={ STATIC_BASE_URL + 'images/public/forbes-insight-cloud.jpg'} alt="forbes lead insights cloud"/>
              <img class="bidi-arrows" src={ STATIC_BASE_URL + 'images/public/icons/bidirectional-arrows.svg'} alt="bidirectional data communication"/>
              <img class="array" src={ STATIC_BASE_URL + 'images/public/forbes-insight-array.jpg'} alt="Forbes lead insights array of services"/>
            </div>
          </section>
          <section class="full grey">
            <h2>Listen, Respond, Learn</h2>
  
            <div class="cols">
                <div class="col">
                  <ul>
                    <li>Provides a conversational connection with the employee</li>
                    <li>Does not require human intervention</li>
                    <li>Leverages the information available in the HR systems and documents
                    </li>
                    <li>“Listens” to conversations with HR, responds with actions and transactions, and learns to enhance the knowledge base</li>
                  </ul>
                </div>
                <div class="col">
                  <ul>
                    <li>Easy and secure way for employee to interact with HR systems</li>
                    <li>Accesses policy content via natural language (leveraging machine learning)</li>
                    <li>Increases the amount of data and insights from employees
                    </li>
                    <li>
                      Shifts HR's effort from low value, repetitive activities into high value activities
                    </li>
                  </ul>
                </div>
            </div>
            
          </section>
          <div class="mainWrp">
            <section>
              <h2>Why invest in an AI Digital Assistant?</h2>
              <h3>Increase HR's efficiency and automate transactional work</h3>
              <blockquote>
                54% of all employees will require significant reskilling and upskilling by 2022
                <span>The World Economic Forum</span>
              </blockquote>
              <h3>Reskill and upskill HR</h3>
              <blockquote>
                Penetration rate of Cloud based AI Digital Assistants for Enterprise
                Applications will reach 87% by 2020 according to Deloitte
              </blockquote>
            </section>
          </div>
          <section class="full grey">
            { calltoaction }
          </section>
        </div>
    }
}


// WEBPACK FOOTER //
// ./ts/Forbeshrassistant.tsx